import { useTranslation } from 'react-i18next';
import ConditionalRenderer from '../ui/custom/ConditionalRenderer';
import Overlay from '../ui/custom/Overlay';
import Text from '../ui/custom/dataDisplay/Text';

export const ReportOverlay = ({ condition }: { condition: boolean }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'manageScheduledLessonReport',
  });

  return (
    <ConditionalRenderer condition={condition}>
      <Overlay
        type="other"
        color="base"
        className="flex flex-col gap-6 items-center justify-center text-center"
      >
        <Text
          text={t('cantEditReport')}
          format="rubik-500"
          size="text-24"
          className="text-primary"
        />
        <div className="flex flex-col gap-1">
          <Text text={t('reportFromAnotherTeacherMessage')} />
          <Text text={t('contactAdminMessage')} />
        </div>
      </Overlay>
    </ConditionalRenderer>
  );
};
